import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Form, FormActions, FormInput, FormTextArea } from '../../../../components/form/index.js';
import { useCategoryContext } from '../../../../contexts/categories/category.tsx';
import { Category } from '../../../../models/category.ts';

const validationSchema = Yup.object().shape({
    name: Yup
        .string()
        .required('Name is required')
        .min(2, "Name is too short")
        .max(255, 'Name is too long'),
    description: Yup.string().nullable(),
});

const CategoryBody = () => {
    const { id } = useParams(); // Get the 'id' from the route parameter
    const {
        isLoaded,
        category,
        insertCategory,
        updateCategory } = useCategoryContext();
    const [localCategory, setLocalCategory] = useState<Category>(category);
    useEffect(() => {
        setLocalCategory(category);
    }, [category])
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;

        setLocalCategory((prevData: Category) => ({
            ...prevData,
            [id]: value, // Update the corresponding field in state
        }));

        validationSchema
            .validateAt(id, { ...localCategory, [id]: value })
            .then(() => setErrors((prev) => ({ ...prev, [id]: '' })))
            .catch((err) => setErrors((prev) => ({ ...prev, [id]: err.message })));
    };

    const handleSubmit = () => {
        validationSchema
            .validate(localCategory, { abortEarly: false })
            .then(() => {
                setLocalCategory(localCategory);
                if (id === "create")
                    insertCategory(localCategory);
                else
                    updateCategory(localCategory);
            })
            .catch((err) => {
                const validationErrors: Record<string, string> = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    if (error.path) validationErrors[error.path] = error.message;
                });
                setErrors(validationErrors);
            });
    };

    if (!isLoaded) return;
    return (
        <Form>
            <FormInput
                entity={localCategory}
                handleInputChange={handleInputChange}
                fieldName='name'
                label='Name'
                errors={errors} />
            <FormTextArea
                entity={localCategory}
                handleInputChange={handleInputChange}
                fieldName='description'
                label='Description'
                errors={errors} />
            <FormActions
                mainAction={handleSubmit}
                mainActionText="Save"
                showCancelButton
            />
        </Form>
    );
};

export default CategoryBody;